import { SolutionOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { FaBriefcaseMedical } from "react-icons/fa";
import { FaNotesMedical } from "react-icons/fa";
import { LiaFileMedicalAltSolid } from "react-icons/lia";
import { HiMiniBanknotes } from "react-icons/hi2";
import { FaPlane } from "react-icons/fa6";
import { MdOutlineAirplaneTicket } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { TbPlaneOff } from "react-icons/tb";

export const items = [
  {
    key: "sub1",
    label: "Solicitudes",
    icon: <SolutionOutlined />,
    children: [
      {
        key: "1",
        icon: <FaBriefcaseMedical />,
        label: (
          <NavLink
            to="/reportecom"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Afiliados Dispersados
          </NavLink>
        ),
      },
      {
        key: "2",
        icon: <FaNotesMedical />,
        label: (
          <NavLink
            to="/prodicciondia"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Producción Diaria
          </NavLink>
        ),
      },
      {
        key: "3",
        icon: <LiaFileMedicalAltSolid />,
        label: (
          <NavLink
            to="/estadonuct"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Estado Nuct
          </NavLink>
        ),
      },
      {
        key: "4",
        icon: <HiMiniBanknotes />,
        label: (
          <NavLink
            to="/pagocomisiones"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Pago de Comisiones
          </NavLink>
        ),
      },
    ],
  },
  {
    key: "sub2",
    label: "Viáticos",
    icon: <EnvironmentOutlined />,
    children: [
      {
        key: "5",
        icon: <FaPlane />,
        label: (
          <NavLink
            to="/viajes"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Planificar Viajes
          </NavLink>
        ),
      },
      {
        key: "6",
        icon: <MdOutlineAirplaneTicket />,
        label: (
          <NavLink
            to="/registrarviajes"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Registro de Viajes
          </NavLink>
        ),
      },
      {
        key: "7",
        icon: <TbReportSearch />,
        label: (
          <NavLink
            to="/reporteplanviajes"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Reporte de Viajes
          </NavLink>
        ),
      },
      {
        key: "8",
        icon: <TbPlaneOff />,
        label: (
          <NavLink
            to="/editarviaje"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Editar Viaje No Autorizado
          </NavLink>
        ),
      },
    ],
  },
];

